import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportDeclaracaoExteriorMedicoRequest, ReportDeclaracaoExteriorMedicoResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './declaracao-exterior-medico.model';

/** Cliente HTTP do relatório assíncrono Declaração para Apresentação no Exterior (Médico). */
@Injectable({ providedIn: 'root' })
export class DeclaracaoExteriorMedicoService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.reports.declaracaoExteriorMedico;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportDeclaracaoExteriorMedicoRequest): Observable<HttpResponse<ReportDeclaracaoExteriorMedicoResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportDeclaracaoExteriorMedicoResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportDeclaracaoExteriorMedicoRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
